import React, { Component } from 'react';
import Logo from './Logo';
import ProfileInfo from './profile-info/ProfileInfo';
import MonitorPlayersMenu from './menu/monitor-players';
import './Sidebar.scss';

class Sidebar extends Component {
    render() {
        return (
            <div
                className={
                    this.props.isCollapsed ? 'sidebar collapsed' : 'sidebar'
                }
            >
                <div className="sidebar-top">
                    <Logo isCollapsed={this.props.isCollapsed} />

                    <MonitorPlayersMenu />
                    {/*<MonitorUsersMenu/>*/}
                </div>
                <div className="sidebar-bottom">
                    <ProfileInfo />
                </div>
            </div>
        );
    }
}

export default Sidebar;
